// src/components/ErrorModal.tsx
import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

interface ErrorModalProps {
    open: boolean;
    title?: string;
    message: string;
    onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ open, title, message, onClose }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0,0,0,0.7)'
                }
            }}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 2,
                    p: 4,
                    width: '90%',
                    maxWidth: 500,
                    boxShadow: 24
                }}
            >
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {title || 'エラー'}
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    {message}
                </Typography>
                <Button variant="contained" onClick={onClose}>
                    閉じる
                </Button>
            </Box>
        </Modal>
    );
};

export default ErrorModal;
